"use strict";

module.exports = require("./Dashboard.js");